export default "__VITE_ASSET__CmrTCzEm__"